// extracted by mini-css-extract-plugin
export var arrowDown = "cameraTechnicalDetail-module--arrowDown--1cf69";
export var arrowUp = "cameraTechnicalDetail-module--arrowUp--2a76d";
export var btnFacebook = "cameraTechnicalDetail-module--btn-facebook--2d9f3";
export var btnLinkedin = "cameraTechnicalDetail-module--btn-linkedin--e182d";
export var btnWechat = "cameraTechnicalDetail-module--btn-wechat--812a8";
export var btnXing = "cameraTechnicalDetail-module--btn-xing--2da2a";
export var btnYoutube = "cameraTechnicalDetail-module--btn-youtube--db53b";
export var detailContainer = "cameraTechnicalDetail-module--detailContainer--0f848";
export var expandButton = "cameraTechnicalDetail-module--expandButton--8e288";
export var icon = "cameraTechnicalDetail-module--icon--036fb";
export var iconText = "cameraTechnicalDetail-module--icon-text--fccc4";
export var mail = "cameraTechnicalDetail-module--mail--163ab";
export var phone = "cameraTechnicalDetail-module--phone--709aa";
export var printer = "cameraTechnicalDetail-module--printer--9b08a";
export var tableInfo = "cameraTechnicalDetail-module--tableInfo--333bf";
export var tableWrapper = "cameraTechnicalDetail-module--tableWrapper--199d4";
export var technicalDetails = "cameraTechnicalDetail-module--technicalDetails--56354";